import { Component, OnInit, inject, signal, WritableSignal } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { LocalStorageService } from '@services/local-storage-service';
import { ApiClientConstant } from '@cureskin/api-client';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'submit-default-answers-sheet',
  imports: [
    ButtonCtaComponent,
  ],
  templateUrl: './submit-default-answers-sheet.component.html',
})
export class SubmitDefaultAnswersSheetComponent implements OnInit {
  private readonly eventLoggerService = inject(EventLoggerService);
  data: {
    userFirstName: string;
    handleViewReportClick: (isLoading: WritableSignal<boolean>) => Promise<void>;
    handleCompleteConsultationClick: (isLoading: WritableSignal<boolean>) => void;
    handleCancelClick: () => void;
    privateMainConcernClass: string;
  } = inject(MAT_BOTTOM_SHEET_DATA);
  isLoading = signal(false);
  private readonly localStorageService = inject(LocalStorageService);
  ApiClientConstant = ApiClientConstant;


  ngOnInit(): void {
    this.eventLoggerService.cleverTapEvent('impression', JSON.stringify({ name: 'chat_skip_questions_bs' }));
    this.updateBottomSheetVisibility();
  }

  async handleViewReportClick(): Promise<void> {
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'chat_skip_questions_view_report' }));
    await this.data.handleViewReportClick(this.isLoading);
  }

  handleCompleteConsultationClick(): void {
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'chat_skip_questions_complete_chat' }));
    this.data.handleCompleteConsultationClick(this.isLoading);
  }

  updateBottomSheetVisibility(): void {
    const privateMainConcernClass = this.data?.privateMainConcernClass;
    if (!privateMainConcernClass) return;

    const consultationsDetails: Array<{
      objectId: string;
      privateMainConcernClass: string;
      isSubmitDefaultAnswerSheetShow: boolean;
    }> = this.localStorageService.getJsonValue('consultationsDetails', '[]');

    const existingIndex = consultationsDetails.findIndex(
      (item) => item.privateMainConcernClass === privateMainConcernClass
    );

    if (existingIndex >= 0) {
      consultationsDetails[existingIndex].isSubmitDefaultAnswerSheetShow = true;
    } else {
      consultationsDetails.push({
        objectId: '',
        privateMainConcernClass,
        isSubmitDefaultAnswerSheetShow: true,
      });
    }

    this.localStorageService.setJsonValue('consultationsDetails', consultationsDetails);
  }

  closeBottomSheet(): void {
    this.data.handleCancelClick();
  }
}

